module.exports = __webpack_public_path__ + "img/attendance_2.c5b2e7a8.png";